export const FETCH_SPINS_REQUEST = "FETCH_SPINS_REQUEST";
export const FETCH_SPINS_SUCCESS = "FETCH_SPINS_SUCCESS";
export const FETCH_SPINS_FAIL = "FETCH_SPINS_FAIL";
export const FETCH_SPIN_REQUEST = "FETCH_SPIN_REQUEST";
export const FETCH_SPIN_SUCCESS = "FETCH_SPIN_SUCCESS";
export const FETCH_SPIN_FAIL = "FETCH_SPIN_FAIL";
export const DOWNLOAD_SPINS_REQUEST = "DOWNLOAD_SPINS_REQUEST";
export const DOWNLOAD_SPINS_SUCCESS = "DOWNLOAD_SPINS_SUCCESS";
export const DOWNLOAD_SPINS_FAIL = "DOWNLOAD_SPINS_FAIL";
